<div class="contentCard">
  <div class="pageNameCont">
    <img src="../../../../assets/images/applications_icon.svg" alt="Application-icon" />
    <h2>Applications</h2>
  </div>
  
  
  <!-- <div class="tabs col-12">
    <div class="tab-item activeTab" [class.activeTab]="viewMode == 'tab1'" rel="tab1" (click)="viewMode = 'tab1'">
      All Applications
    </div>
    <div class="tab-item" [class.activeTab]="viewMode == 'tab2'" rel="tab2" (click)="viewMode = 'tab2'">
      Recently Opened
    </div>
    <div class="tab-item" [class.activeTab]="viewMode == 'tab3'" rel="tab3" (click)="viewMode = 'tab3'">
      My Favourites
    </div>
  </div> -->

  <ng-container >
    <div class="productContainer">
      <p>Here’s a list of Applications that our platform offers</p>
      <div class="productsGrid">
        <!-- <div class="productCard" *ngFor="let moduleItem of getApplicationsModules"
        [ngClass]="!moduleItem.moduleLink ? 'comingSoon' : ''">
          <div class="likeBtn" *ngIf="userId">
            <img class="default" src="../../../../assets/images/favourite_Btn_Icon_default.svg"
              alt="like-product-icon-default" />
            <img class="active" src="../../../../assets/images/favourite_Btn_Icon_active.svg"
              alt="like-product-icon-active" />
          </div>
          <!-- Favourite product button ends -->
          <!-- src="../../../../assets/images/pairing_AAP.png"
          <div class="card-main-content">
            <img class="productBanner cstm-height" [src]="(moduleByteMap[moduleItem.moduleName] 
              || moduleByteMap['Tyre Pairing']) | base64: 'image/png'" alt="img" />
            <div class="productDetails">
              <h3 title="{{ moduleItem.moduleName }}">
                {{ moduleItem.moduleName }}
              </h3>
              <p class="product-desc-wrapper">
                {{ moduleItem.moduleLongDescription }}
              </p>
              <span><a class="tertiary_green_link_btn" (click)="viewMore(moduleItem.id)">View More</a></span>
            </div>
          </div>

          <div>              
            <div *ngIf="!userId && !isUserLoggedIn">
              <a class="btnText" (click)="onSignIn()">
                Sign In
                <span><img class="smallerIcons" src="../../../../assets/images/btn_icon.svg"
                    alt="visit-site" /></span>
              </a>
            </div>

            <div *ngIf="moduleItem.subscription && userId&& isUserLoggedIn">
              <a class="btnText" (click)="onApplicationsApicall(moduleItem.moduleLink)">
                Visit Site
                <span><img class="smallerIcons" src="../../../../assets/images/btn_icon.svg"
                    alt="visit-site" /></span>
              </a>
            </div>

            <div *ngIf="moduleItem.subscription == false && userId && isUserLoggedIn">
              <a class="btnText" (click)="onSubscribe()">
                Subscribe
                <span><img class="smallerIcons" src="../../../../assets/images/btn_icon.svg"
                    alt="visit-site" /></span>
              </a>
            </div>

            <p class="coming_soon" [ngClass]="moduleItem.moduleLink ? 'display_none' : ''">
              Coming Soon
            </p>
          </div>
        </div> -->
        <!-- Product card ends -->

        <div class="productCard new" *ngFor="let module of getApplicationsModules">
          <img [src]="(moduleByteMap[module.moduleName]) | base64: 'image/png'" [alt]="module.moduleName" class="prodImg">
          <div class="productDetailsCont">
            <h3 class="prodName">{{ module.moduleName }}</h3>
            <button *ngIf="false" class="bookmarkBtn"><img src="/assets/images/bookmarksIcon.svg" alt=""></button>
          </div>
          <div class="productDetailsCont">
            <p class="prodDesc">{{ module.moduleShortDescription }}</p>
            <div></div>
          </div>
          <div class="twoBtns">
            <p class="tag new justStart" *ngIf="module.moduleLink == ''">Coming Soon</p>
            <button class="secondary" *ngIf="!userId && !isUserLoggedIn&&module.moduleLink" (click)="onSignIn()">
            <img src="/assets/images/locked.svg" alt="">
                Request Access
            </button>
            <button class="secondary" *ngIf="module.subscription == false&&module.moduleLink&& module.accessCompleted == undefined &&userId &&isUserLoggedIn"
                                        (click)="module.moduleName=='Data Portal' ? onRequestAccessClick(module) : onSubscribe()">
                <img src="/assets/images/locked.svg" alt="">
                Request Access
            </button>

            <button class="secondary"
                                        *ngIf="module.subscription == false&& module.accessCompleted != undefined && module.accessCompleted == false && userId &&isUserLoggedIn"
                                        (click)="onAccessPending()">
                                        <img src="/assets/images/locked.svg" alt="" />
                                        Access Pending
            </button>

            <button class="primary" *ngIf="module.subscription && userId && isUserLoggedIn" (click)="onApplicationsApicall(module.moduleLink)">
                Open Application
            </button>
      <button class="dmintLinkBtn" [routerLink]="['/app-details', (module.moduleId || module.id)]">
        View Details
      </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <ng-container>
      <div class="modal-popup-container container-fluid" *ngIf="isViewMoreVisible">
        <ng-container>
          <div class="modal-card col-6">
            <div class="likeBtn true" *ngIf="userId">
              <img class="default" src="../../../../assets/images/favourite_Btn_Icon_default.svg"
                alt="like-product-icon-default" />
              <img class="active" src="../../../../assets/images/favourite_Btn_Icon_active.svg"
                alt="like-product-icon-active" />
            </div>
            <img class="productBanner" [src]="(moduleByteMap[getModuleDatabyId.moduleName] 
                || moduleByteMap['Tyre Pairing']) | base64: 'image/png'" alt="img" />
            <div class="productDetails">
              <h3>{{ getModuleDatabyId.moduleName }}</h3>
              <p class="product-desc-wrapper">
                {{ getModuleDatabyId.moduleLongDescription }}
              </p>
            </div>
            <div class="ctaCont col-12">
              <button class="tertiary_green_link_btn" (click)="onViewMoreClose()">
                Close
              </button>
              <div *ngIf="!userId && !isUserLoggedIn">
                <a class="btnText" (click)="onSignIn()">
                  Sign In
                  <span><img class="smallerIcons" src="../../../../assets/images/btn_icon.svg"
                      alt="signin-site" /></span>
                </a>
              </div>
              <div *ngIf="getModuleDatabyId.subscription && userId && isUserLoggedIn">
                <a class="btnText primary_green_btn" (click)="onApplicationsApicall(getModuleDatabyId.moduleLink)">
                  Visit Site
                  <span><img class="smallerIcons" src="../../../../assets/images/btn_icon.svg"
                      alt="visit-site" /></span>
                </a>
              </div>
              <div *ngIf="getModuleDatabyId.subscription == false && userId && isUserLoggedIn">
                <a class="btnText" (click)="onSubscribe()">
                  Subscribe
                  <span><img class="smallerIcons" src="../../../../assets/images/btn_icon.svg"
                      alt="subscribe-site" /></span>
                </a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      
    </ng-container> -->

    <!-- <ng-container id="tab2" class="tab-slider--body" *ngSwitchCase="'tab2'">
      <div class="messageContainer col-12">
        <img src="../../../../assets/images/noRecents.svg" alt="no-recently-opened-products" />
        <div class="message">
          <h1>You have not opened any Applications so far.</h1>
          <p>Visit the products to view recently opened products here.</p>
        </div>
        <div class="primary_green_btn">
          <a class="btnText" (click)="backToAllApplication()">BACK TO ALL APPLICATIONS</a>
        </div>
      </div>
    </ng-container>
    <ng-container id="tab3" class="tab-slider--body" *ngSwitchCase="'tab3'">
      <div class="messageContainer col-12">
        <img src="../../../../assets/images/noFavs.svg" alt="no-favourites-products" />
        <div class="message">
          <h1>You do not have any favourites.</h1>
          <p>
            Click on
            <span><img src="../../../../assets/images/favourite_Btn_Icon_default.svg" alt="" /></span>
            this icon to add products to the favourites.
          </p>
        </div>
        <div class="primary_green_btn">
          <a class="btnText" style="padding: 0 !important" (click)="backToAllApplication()">BACK TO ALL
            APPLICATIONS</a>
        </div>
      </div>
    </ng-container> -->
  </ng-container>
</div>

<app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>

<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandler()"></app-alert>